import { render, staticRenderFns } from "./ProductResearch.vue?vue&type=template&id=1d515d06&scoped=true"
import script from "./ProductResearch.vue?vue&type=script&lang=js"
export * from "./ProductResearch.vue?vue&type=script&lang=js"
import style0 from "./ProductResearch.vue?vue&type=style&index=0&id=1d515d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d515d06",
  null
  
)

/* custom blocks */
import block0 from "./ProductResearch.vue?vue&type=custom&index=0&blockType=section&class=py-8%20bg-gray-50"
if (typeof block0 === 'function') block0(component)
import block1 from "./ProductResearch.vue?vue&type=custom&index=1&blockType=div&class=solution-section"
if (typeof block1 === 'function') block1(component)
import block2 from "./ProductResearch.vue?vue&type=custom&index=2&blockType=div&class=solution-section"
if (typeof block2 === 'function') block2(component)
import block3 from "./ProductResearch.vue?vue&type=custom&index=3&blockType=div&class=solution-section%20alt-bg"
if (typeof block3 === 'function') block3(component)

export default component.exports